import { IQService } from "angular";
import { getExceptionMessage } from "../../core/data-utils";
import { EmploymentProcessingService } from "../../core/services";
import { ProcessingState, DirectDepositVM } from "./employment-processing-models";

export class DirectDepositProcessor {
    constructor(private $q: IQService, private employmentProcessingService: EmploymentProcessingService) {
        'ngInject';
    }

    batchProcessDirectDeposit(directdeposit: DirectDepositVM[]) {
        const chunkResult = directdeposit.reduce((processingResult, dd) => {
            dd.processingState = ProcessingState.Processing;
            const saved = this.employmentProcessingService.processDirectDeposit(dd.EmployeeID, dd.DirectDepositID)
                .then(() => {
                    dd.processingState = ProcessingState.Processed;
                    dd.IsSelected = false;
                    processingResult.succeeded++;
                })
                .catch(ex => {
                    dd.processingState = ProcessingState.Failed;
                    processingResult.failed++;
                    processingResult.messages.push(`failed to process ${dd.EmployeeID}: `
                        + getExceptionMessage(ex));
                });
            processingResult.promises.push(saved);
            return processingResult;
        }, { succeeded: 0, failed: 0, messages: [], promises: [] });
        return this.$q.all(chunkResult.promises)
            .then(() => chunkResult);
    }
}
